import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'

export default {
  name: 'thc-query-summary',
  components: {
    Paginate,
    VueElementLoading
  },
  props: [],
  data() {
    return {
      isLoading: false,
      THCno: '',
      THCNoError: '',
      THCNoDetails: [],
      THCNoLogDetails: [],
      THCNoLogModal: false,
      UpdateStatusModal: false,
      modaldata: '',
      IsAllowToUpdateStatus: false,
      hublist: [],
      useremail:'',
      RemoveLogModal:false,
      logdata:''
    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
  },
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    this.token = JSON.parse(userToken)
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail[0].email;
    this.getHubList();
  },
  methods: {
    getHubList() {
      this.hublist = []
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          var HubDetails = result.data.ResponseData
          for (var i = 0; i < HubDetails.length; i++) {
            this.hublist.push({
              "value": HubDetails[i].HubID,
              "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
            })
          }
        }, error => {
          console.error(error)
        })
    },
    getTHCNoDetails() {
      if (this.THCno == '') {
        this.THCNoError = 'The THC No field is required.'
      } else {
        this.THCNoError = ''
        var THCNoDetails = []
        var THCNoLogDetails = []
        this.THCNoDetails = []
        this.THCNoLogDetails = []
        this.isLoading = true
        axios({
            'method': 'GET',
            'url': apiUrl.api_url_hubops + 'getTHCDetailsByTHCNo?THCNO=' + this.THCno,
            'headers': {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            this.isLoading = false
            if (result.data.ResultCode == 100) {
              THCNoDetails = result.data.ResponseData.ScheduleDetails
              THCNoLogDetails = result.data.ResponseData.ScheduleLogDetails
              var hubDetails = [];
              var THCNoData = [];
              var THCNoLogData = [];
              for (var i = 0; i < this.hublist.length; i++) {
                hubDetails[this.hublist[i].value] = this.hublist[i].text;
              }
              if (THCNoDetails.length > 0) {
                THCNoDetails.forEach(function(item) {
                  item["currenthubname"] = '';
                  if (item.currenthubid && hubDetails[item.currenthubid]) {
                    item["currenthubname"] = hubDetails[item.currenthubid];
                  }
                  THCNoData.push(item);
                });
              }
              this.THCNoDetails = THCNoData;
              if (THCNoLogDetails.length > 0) {
                THCNoLogDetails.forEach(function(item) {
                  item["currenthubname"] = '';
                  if (item.currenthubid && hubDetails[item.currenthubid]) {
                    item["currenthubname"] = hubDetails[item.currenthubid];
                  }
                  THCNoLogData.push(item);
                });
              }
              this.THCNoLogDetails = THCNoLogData;

            } else {
              this.THCNoDetails = []
              this.THCNoLogDetails = []
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            this.isLoading = false
            console.error(error)
          })
      }
    },
    showLogDetails() {
      this.THCNoLogModal = true
    },
    closeLogDetails() {
      this.THCNoLogModal = false
    },
    removeTHCNoDetails() {
      this.input = {
        "connectionschedulemasterlogid" : this.logdata.connectionschedulemasterlogid
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'removeCSMLogByLogId',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage)
            this.RemoveLogModal = false
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    openUpdateStatusModal(data) {
      this.UpdateStatusModal = true
      this.modaldata = data
    },
    closeUpdateStatusModal() {
      this.UpdateStatusModal = false
      this.IsAllowToUpdateStatus = false
    },
    updateStatus() {
      this.input = {
        "thcNo": this.THCno,
        "lastModifiedBy": this.useremail
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'updateScheduleStatusByThcNo',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage)
            this.closeUpdateStatusModal()
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    resetForm() {
      this.isLoading = false
      this.THCno = ''
      this.THCNoError = ''
      this.THCNoDetails = []
      this.THCNoLogDetails= []
      this.THCNoLogModal= false
      this.UpdateStatusModal= false
      this.modaldata= ''
      this.IsAllowToUpdateStatus= false
    },
    openRemoveLogModal(data){
      this.logdata=data
      this.RemoveLogModal = true
    },
    closeRemoveLogModal(){
      this.RemoveLogModal = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/THCQuerySummary/THCQuerySummary.js